// Module
var code = "<a ui-sref={{navLink.state}} class=nav-link ng-class=navLink.buildLinkClassObject()> <ng-transclude></ng-transclude> </a> ";
// Exports
module.exports = code;